export interface IStatusHistoryItem {
  time: string;
  status: string;
}

export interface IStatusHistory {
  date: string;
  records: IStatusHistoryItem[];
}
